import { render, staticRenderFns } from "./DialogEditThayDongHoDienNuoc.vue?vue&type=template&id=370ca96b"
import script from "./DialogEditThayDongHoDienNuoc.vue?vue&type=script&lang=js"
export * from "./DialogEditThayDongHoDienNuoc.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports